import { Network } from '@capacitor/network';
import sqliteService from './sqliteService';
import api from '../api/axios';

/**
 * Servicio encargado de la sincronización automática de datos entre SQLite y el servidor.
 * Escucha cambios en el estado de la red para disparar procesos de subida pendientes.
 */
class SyncService {
    constructor() {
        this.isSyncing = false;
    }

    /**
     * Inicializa los observadores de red para detectar cambios de conexión.
     */
    init() {
        // Escuchar cambios de estado de red
        Network.addListener('networkStatusChange', (status) => {
            console.log('Cambio de red detectado:', status);
            if (status.connected) {
                this.syncPendingData();
            }
        });

        // Verificación inicial al arrancar
        this.checkInitialStatus();
    }

    /**
     * Comprueba el estado inicial de la red al iniciar la aplicación.
     */
    async checkInitialStatus() {
        const status = await Network.getStatus();
        if (status.connected) {
            this.syncPendingData();
        }
    }

    /**
     * Coordina la sincronización de todos los datos pendientes (listas, tickets, etc.).
     */
    async syncPendingData() {
        if (this.isSyncing) return;
        this.isSyncing = true;

        console.log('Iniciando sincronización automática de datos pendientes...');

        try {
            await this.syncPendingTickets();
            // Aquí se pueden añadir más procesos como syncPendingLists() si fuera necesario
        } catch (error) {
            console.error('Error durante la sincronización automática:', error);
        } finally {
            this.isSyncing = false;
        }
    }

    /**
     * Procesa y sube los tickets almacenados localmente en SQLite.
     */
    async syncPendingTickets() {
        const pendingTickets = await sqliteService.getPendingTickets();
        
        if (pendingTickets.length === 0) {
            console.log('No hay tickets pendientes de sincronizar.');
            return;
        }

        console.log(`Sincronizando ${pendingTickets.length} tickets pendientes...`);

        for (const ticket of pendingTickets) {
            try {
                // Lógica de subida (ejemplo: leer archivo y enviar via multipart)
                // Nota: La implementación exacta depende de cómo se guarden las imágenes en el dispositivo
                // y del endpoint específico de OCR del backend.
                
                // const success = await this.uploadTicket(ticket);
                // if (success) {
                //     await sqliteService.markTicketAsSynced(ticket.id);
                // }
                
                console.log(`Ticket ${ticket.id} procesado (simulado)`);
            } catch (err) {
                console.error(`Error sincronizando ticket ${ticket.id}:`, err);
            }
        }
    }
}

export default new SyncService();
